var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tnc-setup-container" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "el-col",
            { staticClass: "tnc-content", attrs: { span: 12 } },
            [
              _c("p", { staticClass: "step-text" }, [_vm._v("STEP 2 OF 3")]),
              _vm._v(" "),
              _c("h2", [_vm._v("Terms and Conditions")]),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v("Just a few more steps and you’re finished!")
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "pdf-container" },
                      [
                        _c("vue-pdf-embed", {
                          attrs: {
                            "page-width": "auto",
                            height: 800,
                            source: _vm.pdfSource
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "tNCForm",
                  attrs: { model: _vm.tNCForm, rules: _vm.tNCFormRules }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: { prop: "tncAccept" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "tnc-checkbox-wrapper" },
                                [
                                  _c("el-checkbox", {
                                    model: {
                                      value: _vm.tNCForm.tncAccept,
                                      callback: function($$v) {
                                        _vm.$set(_vm.tNCForm, "tncAccept", $$v)
                                      },
                                      expression: "tNCForm.tncAccept"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tnc-checkbox-label" },
                                    [
                                      _vm._v(
                                        "\n                    I agree to the Terms and Conditions of the Channel Partner Membership Agreement,\n                    "
                                      ),
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.viewPrivacyPolicy(
                                                $event
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Privacy policy")]
                                      ),
                                      _vm._v(
                                        "\n                    and\n                    "
                                      ),
                                      _c(
                                        "el-link",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.viewTnC($event)
                                            }
                                          }
                                        },
                                        [_vm._v("Terms of service")]
                                      ),
                                      _vm._v(".\n                  ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "p",
                          {
                            staticClass: "acknowledge-text",
                            on: { click: _vm.toggleTnCAccept }
                          },
                          [
                            _vm._v(
                              "* I acknowledge and agree that I will not now or in\n                the future, directly or indirectly, contact, negotiate with, or enter into any agreement with the\n                developer or agent introduced by UNIFI, for the purpose of bypassing, excluding, or diminishing UNIFI’s\n                involvement in this or any related transactions."
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "next-button",
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.tNCForm.tncAccept
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.acceptTnc("tNCForm")
                                    }
                                  }
                                },
                                [_vm._v("Next\n                ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be0bf1e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be0bf1e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/steps/userDetailsSteps/uConnectTnCStep.vue
// module id = null
// module chunks = 